/**
 * Vuely Global Components
 */
import ConfigLoader from '@/helpers/config-loader'
import env from '@/config.js'
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import AppSectionLoader from "Components/AppSectionLoader/AppSectionLoader";
import { RotateSquare2 } from "vue-loading-spinner";
// delete Confirmation Dialog
import DeleteConfirmationDialog from "Components/DeleteConfirmationDialog/DeleteConfirmationDialog";

// page title bar
import PageTitleBar from "Components/PageTitleBar/PageTitleBar";

// App Card component
import AppCard from 'Components/AppCard/AppCard';

// stats card
import StatsCard from 'Components/StatsCard/StatsCard';
import StatsCardV2 from 'Components/StatsCardV2/StatsCardV2';
import WidgetCard from 'Components/WidgetCard/WidgetCard';

// section tooltip
import SectionTooltip from "Components/SectionTooltip/SectionTooltip"
import VuetifyConfirm from 'vuetify-confirm'

import 'chartjs-plugin-colorschemes'
// Devextreme

import {
   DxChart,
   DxAdaptiveLayout,
   DxCommonSeriesSettings,
   DxTooltip,
 } from 'devextreme-vue/chart'
 
 import {
   DxPivotGrid,
   DxFieldChooser,
   DxFieldPanel,
   DxExport,
   DxScrolling
 } from 'devextreme-vue/pivot-grid'

 import {
    DxDataGrid,
    DxColumn,
    DxFilterPanel,
    DxFilterRow,
    DxFilterBuilderPopup,
    DxGroupPanel,
    DxGrouping,
    DxPaging,
    DxPager,
    DxSummary,
    DxTotalItem
 } from 'devextreme-vue/data-grid'


const GlobalComponents = {
   install(Vue) {
      Vue.component('appCard', AppCard);
      Vue.component('sectionTooltip', SectionTooltip);
      Vue.component('statsCard', StatsCard);
      Vue.component('statsCardV2', StatsCardV2);
      Vue.component('deleteConfirmationDialog', DeleteConfirmationDialog);
      Vue.component('vuePerfectScrollbar', VuePerfectScrollbar);
      Vue.component('appSectionLoader', AppSectionLoader);
      Vue.component('pageTitleBar', PageTitleBar);
      Vue.component('rotateSquare2', RotateSquare2);
      Vue.component('dxDataGrid', DxDataGrid)
      Vue.component('dxColumn', DxColumn),
      Vue.component('widgetCard', WidgetCard),
      Vue.component('DxChart', DxChart),
      Vue.component('DxAdaptiveLayout', DxAdaptiveLayout),
      Vue.component('DxCommonSeriesSettings', DxCommonSeriesSettings),
      Vue.component('DxTooltip', DxTooltip),
      Vue.component('DxPivotGrid', DxPivotGrid),
      Vue.component('DxFieldChooser', DxFieldChooser),
      Vue.component('DxFieldPanel', DxFieldPanel),
      Vue.component('DxDataGrid', DxDataGrid),
      Vue.component('DxColumn', DxColumn),
      Vue.component('DxFilterPanel', DxFilterPanel),
      Vue.component('DxFilterRow', DxFilterRow),
      Vue.component('DxFilterBuilderPopup', DxFilterBuilderPopup),
      Vue.component('DxGrouping', DxGrouping),
      Vue.component('DxPaging', DxPaging),
      Vue.component('DxGroupPanel', DxGroupPanel),
      Vue.component('DxPager', DxPager),
      Vue.component('DxExport', DxExport)
      Vue.component('DxScrolling', DxScrolling)
      Vue.component('DxSummary', DxSummary)
      Vue.component('DxTotalItem', DxTotalItem)
      Vue.use(VuetifyConfirm)

   }
}



export default GlobalComponents
